import { Link, Outlet } from 'react-router-dom';
import { SITE_NAME, SITE_TAGLINE } from '../../config/site';
import styles from './Layout.module.css';

export default function Layout() {
  return (
    <div className={styles.page}>
      <header className={styles.header}>
        <div className={styles.headerInner}>
          <Link to="/" className={styles.brand}>
            <span className={styles.brandIcon} aria-hidden>
              ◈
            </span>
            <span>
              <strong>{SITE_NAME}</strong>
              <small>{SITE_TAGLINE}</small>
            </span>
          </Link>
        </div>
        {/*<AdPlaceholder slot="header" className={styles.adHeader} />*/}
      </header>

      <div className={styles.body}>
        <main className={styles.main}>
          <Outlet />
        </main>
      </div>

      <footer className={styles.footer}>
        {/*<AdPlaceholder slot="footer" className={styles.adFooter} />*/}
        <nav className={styles.footerLinks} aria-label="Footer">
          <Link to="/about-us">About Us</Link>
          <Link to="/privacy-policy">Privacy Policy</Link>
          <Link to="/terms-conditions">Terms and Conditions</Link>
          <Link to="/contact-us">Contact Us</Link>
        </nav>
        <p>
          © {new Date().getFullYear()} {SITE_NAME}. Free online tools for creators and developers.
        </p>
      </footer>
    </div>
  );
}
